import React from "react";
import HeatMap from "react-heatmap-grid";
import "./HeatMapGrid.scss";

const HeatMapGrid = ({ heatMapData, onCellClick }) => {
  // Create x-labels for 24 hours
  const xLabels = new Array(24).fill(0).map((_, i) => i.toString().padStart(2, '0'));

  // Extract unique dates for y-labels and sort them
  const yLabels = [...new Set(heatMapData.map(item => item.date))].sort();

  // Create a map to quickly find data by date and hour
  const dataMap = heatMapData.reduce((acc, item) => {
    if (!acc[item.date]) acc[item.date] = {};
    acc[item.date][item.hour] = item.value;
    return acc;
  }, {});

  // Build the data array for the heatmap
  const data = yLabels.map(date => 
    xLabels.map(hour => 
      dataMap[date][hour] ? dataMap[date][hour] : 0
    )
  );

  // Modify handleCellClick to use the callback
  const handleCellClick = (x, y) => {
    const date = yLabels[y];
    const hour = xLabels[x];
    onCellClick(date, hour);  // Call the callback function with date and hour
  };

  return (
    <div>
      <HeatMap
        xLabels={xLabels}
        yLabels={yLabels}
        xLabelsLocation={"top"}
        xLabelWidth={50}
        yLabelWidth={100}
        data={data}
        squares
        height={30}
        onClick={handleCellClick}
        cellStyle={(background, value, min, max, data, x, y) => ({
          background: `rgb(0, 151, 230, ${1 - (max - value) / (max - min)})`,
          fontSize: "11.5px",
          color: "#444",
        })}
        cellRender={(value) => value && <div>{value}</div>}
      />
    </div>
  );
};

export default HeatMapGrid;
